export default __webpack_public_path__ + "static/media/landing.7804b687.mp4";